import React, { forwardRef } from 'react'
import { PropTypes } from 'prop-types'
import DataConfirmation from '../DataConfirmation'
import ContainerFields from './ContainerFields'

const Confirmation = forwardRef((props, ref) => {
  const { quotation, proposal, quotationStatus } = props
  return (
    <>
      <DataConfirmation
        ref={ref}
        {...props}
      >
        <ContainerFields
          quotation={quotation}
          proposal={proposal}
          quotationStatus={quotationStatus}
        />
      </DataConfirmation>
    </>
  )
})

Confirmation.propTypes = {
  quotation: PropTypes.any.isRequired,
  quotationStatus: PropTypes.any.isRequired,
  proposal: PropTypes.any.isRequired,
}

export default Confirmation
